import { useEffect } from 'react';

interface AppIdentity {
  name: string;
  color: string;
  emoji: string;
}

const APP_MAP: Record<string, AppIdentity> = {
  vision: { name: 'AQL Vision', color: '#8b5cf6', emoji: '👁️' },
};

export function useAppIdentity(appId: string | undefined) {
  useEffect(() => {
    if (!appId) {
      document.title = 'AQL APPS - Ecossistema Industrial';
      updateIcons('🛡️', '#000000');
      return;
    }

    const identity = APP_MAP[appId] || { name: `AQL ${appId.toUpperCase()}`, color: '#64748b', emoji: '🛡️' };
    
    document.title = identity.name;
    updateIcons(identity.emoji, identity.color);

    // Cleanup on unmount or change
    return () => {
      document.title = 'AQL APPS';
    };
  }, [appId]);
}

function updateIcons(emoji: string, color: string) {
  // Update Favicon using SVG Data URL
  const svg = `
    <svg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 100 100%22>
      <rect width=%22100%22 height=%22100%22 rx=%2230%22 fill=%22${encodeURIComponent(color)}%22 />
      <text y=%22.95em%22 font-size=%2275%22 x=%2250%%22 text-anchor=%22middle%22 dominant-baseline=%22central%22 font-family=%22system-ui, sans-serif%22 font-weight=%22bold%22>${emoji}</text>
    </svg>
  `.trim();

  const faviconUrl = `data:image/svg+xml,${svg}`;
  
  // Link selectors
  const selectors = [
    'link[rel="icon"]',
    'link[rel="shortcut icon"]',
    'link[rel="apple-touch-icon"]'
  ];

  selectors.forEach(selector => {
    let link: HTMLLinkElement | null = document.querySelector(selector);
    if (!link) {
      link = document.createElement('link');
      link.rel = selector.includes('apple') ? 'apple-touch-icon' : 'icon';
      document.head.appendChild(link);
    }
    link.href = faviconUrl;
  });

  // Update Theme Color for mobile browser address bar
  let themeColor: HTMLMetaElement | null = document.querySelector('meta[name="theme-color"]');
  if (!themeColor) {
    themeColor = document.createElement('meta');
    themeColor.name = 'theme-color';
    document.head.appendChild(themeColor);
  }
  themeColor.content = color;
}
